import { render, staticRenderFns } from "./IntlPhone.vue?vue&type=template&id=d81f6090&"
import script from "./IntlPhone.vue?vue&type=script&lang=js&"
export * from "./IntlPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports